import patternsData from "./patterns-catalog.json";

interface LocalizedString {
  [lang: string]: string;
}

interface RawPattern {
  id: string;
  slug: string;
  originalId: string;
  name: LocalizedString | string;
  difficulty: string;
  difficultyLabel: LocalizedString | string;
  timeLabel: LocalizedString | string;
  premium: boolean;
  published: boolean;
  images: {
    hero: string;
    gallery: string[];
    thumbnail: string;
  };
}

export interface Pattern {
  id: string;
  slug: string;
  name: string;
  difficulty: string;
  difficultyLabel: string;
  timeLabel: string;
  premium: boolean;
  imageUrl: string;
  patternUrl: string;
}

const { baseImageUrl, patterns: rawPatterns, defaultLanguage } = patternsData as {
  baseImageUrl: string;
  patterns: RawPattern[];
  defaultLanguage: string;
};

function getLocalizedValue(value: LocalizedString | string, lang: string): string {
  if (typeof value === 'string') {
    return value;
  }
  return value[lang] || value[defaultLanguage] || value['en'] || Object.values(value)[0] || '';
}

export function getPatterns(lang: string): Pattern[] {
  return rawPatterns
    .filter((p) => p.published && !p.premium)
    .map((pattern) => ({
      id: pattern.id,
      slug: pattern.slug,
      name: getLocalizedValue(pattern.name, lang),
      difficulty: pattern.difficulty,
      difficultyLabel: getLocalizedValue(pattern.difficultyLabel, lang),
      timeLabel: getLocalizedValue(pattern.timeLabel, lang),
      premium: pattern.premium,
      imageUrl: `${baseImageUrl}/${pattern.images.hero}`,
      patternUrl: lang === defaultLanguage
        ? `/patterns/${pattern.slug}/`
        : `/${lang}/patterns/${pattern.slug}/`,
    }));
}

export const PATTERNS_PER_PAGE = 8;
